import { cleanRemuneration, isExpired } from "../misc";

function asString(val) {
  if (Array.isArray(val)) return val.join(", ");
  return val;
}

export default function toSchema(data) {
  const {
    positionProfile,
    company = {},
    validFrom,
    validTo,
    positionReference,
    id,
    directApply,
  } = data;

  // bail if no position profile
  if (!positionProfile) return {};

  const {
    title = "",
    description,
    hoursType,
    location = {},
    industry,
    category,
    remuneration,
  } = positionProfile;

  const { name: companyName, logoUrlFull: companyLogo } = company;
  const {
    addressLine1,
    addressLine2,
    addressLine3,
    country,
    county,
    city,
    postCode,
    geoLocation = {},
  } = location;
  const { coordinates = [] } = geoLocation;
  const [latitude, longitude] = coordinates[0] || [];

  const hiringOrganization = { "@type": "Organization" };
  if (companyName) hiringOrganization.name = companyName;
  // include logo if in object
  if (companyLogo && companyLogo.length) hiringOrganization.logo = companyLogo;

  const jobLocation = {
    "@type": "Place",
    address: {
      "@type": "PostalAddress",
    },
  };
  const streetAddressParts = [];
  if (addressLine1) streetAddressParts.push(addressLine1);
  if (addressLine2) streetAddressParts.push(addressLine2);
  if (addressLine3) streetAddressParts.push(addressLine3);
  if (streetAddressParts.length > 0) {
    jobLocation.address.streetAddress = streetAddressParts.join(", ");
  }
  if (city) jobLocation.address.addressLocality = city;
  if (country) jobLocation.address.addressCountry = country;
  if (county) jobLocation.address.addressRegion = county;
  if (postCode) jobLocation.address.postalCode = postCode;

  if (latitude && longitude) {
    jobLocation.geo = {
      "@type": "GeoCoordinates",
      latitude,
      longitude,
    };
  }

  const { currency, unitText, fixed, min, max } = cleanRemuneration(
    remuneration || {}
  );

  const baseSalary = {
    "@type": "MonetaryAmount",
    value: {
      "@type": "QuantitativeValue",
    },
  };

  if (currency) baseSalary.currency = currency;
  if (unitText) baseSalary.value.unitText = unitText;

  if (min && max) {
    baseSalary.value.minValue = min;
    baseSalary.value.maxValue = max;
  }
  // min max range takes priority
  if (fixed && !(min && max)) baseSalary.value.value = fixed;

  const schema = {
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    baseSalary: { ...baseSalary },
    datePosted: validFrom || new Date().toISOString().slice(0, 10),
    directApply,
    title,
  };
  
  // no need if not included
  if (description) schema.description = description;
  if (hoursType) schema.employmentType = hoursType;

  // no point if no reference
  if (id || positionReference) {
    schema.identifier = {
      "@type": "PropertyValue",
      name: companyName || "",
      value: id || positionReference,
    };
  }

  // only if at least 2 keys
  if (Object.keys(hiringOrganization).length >= 2)
    schema.hiringOrganization = { ...hiringOrganization };
  // only if at least 2 keys in address
  if (Object.keys(jobLocation.address).length >= 2 || jobLocation.geo)
    schema.jobLocation = { ...jobLocation };

  // if not expired include key/prop
  if (validTo && !isExpired(validTo)) schema.validThrough = validTo;
  // if present
  if (category) schema.occupationalCategory = asString(category);
  if (industry) schema.industry = asString(industry);

  return schema;
}
